import { render, staticRenderFns } from "./HistoricTab.vue?vue&type=template&id=34ba5234"
import script from "./HistoricTab.vue?vue&type=script&lang=js"
export * from "./HistoricTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports